export default "__VITE_ASSET__B_hfws29__"